import React from "react";
import ImageSection from "../../components/common/ImageSection";
import { Ring_circle } from "../../helper/imageConstant";

const Delivery = () => {
  return (
    <>
      <ImageSection name={"Delivery"} />
      <section className="relative p-4 my-5 lg:my-5 xl:pb-14 overflow-hidden fonts text-justify">
        <div className="lg:mx-20 xl:mx-24 2xl:mx-32 3xl:mx-40 4xl:max-w-[1520px] 4xl:mx-auto ">
          <div className="grid grid-cols-1 gap-8">
            <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
              <li>
                Vikas Silk Mills guarantees to deliver products to all cities
                across states of India. Vanya Designer will not be liable for
                delays resulting from incomplete address listings. In the event
                of a reshipment of the same order, customers will be responsible
                to pay re-shipping charges for the reshipment and any related
                fines/penalties. All orders are shipped by the best
                transport/courier agencies and home delivered within
                approximately 3-5 working days after dispatch of the shipment.
              </li>
              <li>
                In case the authorities of such places fail to accept the
                package, for any reason, Vikas Silk Mills will under no
                circumstances issue a refund or credit to the customer's
                account, nor shall Vanya Designer attempt re-shipment of the
                same order. For a special or preferred delivery date, the
                Customer shall necessarily mention the required delivery date in
                the order when placing the order. If the order does not contain
                any delivery date, the package shall be delivered at the first
                opportunity, as soon as possible.
              </li>
              <li>
                Since transport/courier agencies do not deliver to P.O. Box
                address, customers are requested to provide full address with
                pin code / zip code. NOTE: Billing Address shall mean the
                address where a customer receives the credit card bills.
                Shipping address shall mean the address where the order shall
                have to be delivered.
              </li>
              <li>
                Generally no deliveries can be made on Saturdays and Sundays.
                However, in case of emergency, solely at the discretion of Vikas
                Silk Mills delivery may be made on Saturdays.
              </li>
              <li>
                In case customer wishes to avail other alternate shipping
                options, Vikas Silk Mills may then suggest other options. On
                special request, Vanya Designer may also provide special quotes
                for shipping, in case merchandise order amount is large.
                Customer may contact us for further details.
              </li>
              <li>
                In case of multiple orders, Customer may receive the same
                separately, depending on product availability and shipping
                locations.
              </li>
              <li>All products shall be shipped from India.</li>
              <li>
                Vikas Silk Mills shall not give any refund, returns, replacement
                & exchange for reason of delay caused due to the carrier agency.
                However, at its sole discretion, Vanya Designer may agree to
                provide credit which may be used for future orders.
              </li>
              <li>
                Vikas Silk Mills shall intimate by email, in case of delay in
                shipping due to un-availability of stock or due to unusual delay
                in filling an order.
              </li>
            </ul>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                Shipment Time{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  Against each product on the website, an approximate time for
                  shipment has been provided; which are merely indicative.
                  Products may be shipped either earlier or later depending on
                  availability of product and other factors. In Order to get an
                  accurate estimate of shipment time, kindly email the order
                  number or item codes. As far as possible, product orders shall
                  be processed within 48-72 hours of the order being placed with
                  Vikas Silk Mills Expected shipment time is 7-15 business days,
                  all other factors being optimum.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                Tracking of Shipment{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  Vikas Silk Mills shall provide details of shipment via email
                  alerts to the customer, once package is handed across to the
                  carrier agency. The email alerts shall contain the
                  transport/courier agency's website details along with tracking
                  number and expected date of delivery. The Customer may use the
                  said details to keep a check on status of the package.
                </li>
                <li>
                  Please note that tracking numbers for orders shipped may take
                  up to 24 business hours to become active on the websites.
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                Request For Change of Postal Address{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  Postal Address as provided by the Customer may be changed
                  within 24 hours of placing of Order, and not later; Please
                  contact us
                </li>
              </ul>
            </div>
            <div className="space-y-4">
              <h1 className="text-[#A5302E] text-base lg:text-base 3xl:text-lg  font-medium">
                In Case of Delays{" "}
              </h1>
              <ul className="list-disc pl-5 lg:pl-8 text-[#555555] text-base lg:text-base 3xl:text-lg font-normal space-y-4">
                <li>
                  Time to ship mentioned on our website against each item is
                  indicative and approximate values only and sometimes due to
                  situations beyond our control, delays may occur. No refund,
                  returns, replacement & exchange will be entertained for this
                  reason.
                </li>
                <li>
                  If for any reason, there is going to be a delay in shipping
                  because a item is out of stock or If there is an unusual delay
                  in filling an order, we will notify you by e-mail.
                </li>
                <li>
                  However any dates for delivery are approximate only and we are
                  not liable for any delay in delivering your order or any part
                  of it. We may choose to deliver your order in separate parts.
                  In some cases we may offer to refund you for unfulfilled part
                  of the order.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="hidden lg:block absolute lg:bottom-[50%] lg:-right-[8%] xl:-right-[8%] 2xl:-right-[9%] 3xl:bottom-[50%] 3xl:-right-[8%]">
          <div className="lg:w-36 xl:w-44 2xl:w-60 3xl:w-64 h-full">
            <img src={Ring_circle} alt="" className="object-cover" />
          </div>
        </div>
      </section>
    </>
  );
};

export default Delivery;
